import Navbar from "../../component/Navbar";
import DropdownMenu from "../../component/DropdownMenu";
import Footer from "../../component/Footer";
import { person } from "../../inc/Dataperson_inc";
import LogoContent from "../../component/LogoContent";
import { useState } from "react";
import PageTransition from "../../component/PageTransition";

export default function Page() {
  const [showContent, setShowContent] = useState(false);
  return (
    <>
      <PageTransition showContent={showContent} setShowContent={setShowContent}>
        ผู้บริหารศูนย์การเรียนรู้และส่งเสริมสุขภาพทางสัตวแพทย์ภาคเหนือ
      </PageTransition>

      {showContent && (
        <div className="relative">
          <Navbar />
          <div className="flex flex-col gap-y-5">
            <DropdownMenu />
            <LogoContent />
            <div className="container mx-auto w-full px-5 py-5 md:px-0 md:py-0">
              <div className=" h-full w-full flex flex-col  justify-center items-center gap-5">
                <div className="flex gap-x-3">
                  {person.map((item) => (
                    <>
                      {item.positionID === 1 && (
                        <>
                          <div
                            key={item.id}
                            className="w-[250px] h-full  relative"
                          >
                            <img
                              src={
                                item.img ? item.img : "/images/info/notImg.png"
                              }
                              className="object-cover"
                              alt=""
                            />
                            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 bg-[#9E76B3] text-gray-100 text-sm w-full py-3 px-3 rounded-t-lg">
                              <div className="flex flex-col gap-y-2">
                                <div className="flex gap-x-2 justify-center items-center">
                                  {item.prefix} {item.frist_name}{" "}
                                  {item.last_name}
                                </div>
                                <div className="flex gap-x-2 justify-center items-center">
                                  {item.position}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ))}
                </div>

                <div className="lg:flex gap-x-3">
                  {person.map((item) => (
                    <>
                      {item.positionID === 2 && (
                        <>
                          <div
                            key={item.id}
                            className="w-[250px] h-full  relative"
                          >
                            <img
                              src={
                                item.img ? item.img : "/images/info/notImg.png"
                              }
                              className="object-cover"
                              alt=""
                            />
                            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 bg-[#9E76B3] text-gray-100 text-sm w-full py-3 px-3 rounded-t-lg">
                              <div className="flex flex-col gap-y-2">
                                <div className="flex gap-x-2 justify-center items-center">
                                  {item.prefix} {item.frist_name}{" "}
                                  {item.last_name}
                                </div>
                                <div className="flex gap-x-2 justify-center items-center">
                                  {item.position}
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ))}
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
}
